import React, { useEffect, useState } from 'react';
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Checkbox,
    IconButton,
    Chip,
    Button,
    Typography,
    Alert,
    alpha
} from '@mui/material';
import pdf from '../../../assets/Project_Images/Icons/pdf.png'
import reciept from '../../../assets/Project_Images/Icons/reciept.png'
import details from '../../../assets/Project_Images/Icons/details.png'
import { DatePicker, LocalizationProvider, StaticDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { ApiGetInvoiceList } from '../../../../apiService/Core/Apicall.tsx';
import dayjs, { Dayjs } from 'dayjs';
import { toast } from 'react-toastify';
import InvoiceListing from './InvoiceListing.tsx';
import { useLocation } from 'react-router-dom';
import Invoicedetails from './Invoicedetails.tsx';
import { Warning, WarningAmberRounded } from '@mui/icons-material';



function Invoices() {
    const [selectedDate, setselectedDate] = useState<Dayjs>(dayjs());
    const location = useLocation().pathname


    // const isSelected = (invoice: string) => selected.includes(invoice);
    // console.log("location", location)

    // const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     if (event.target.checked) {
    //         const all = invoicelist.map((row) => row.invoice);
    //         setSelected(all);
    //     } else {
    //         setSelected([]);
    //     }
    // };

    // const handleClick = (invoice: string) => {
    //     const selectedIndex = selected.indexOf(invoice);
    //     let newSelected: string[] = [];

    //     if (selectedIndex === -1) {
    //         newSelected = [...selected, invoice];
    //     } else {
    //         newSelected = selected.filter((id) => id !== invoice);
    //     }

    //     setSelected(newSelected);
    // };
    // useEffect(() => {
    //     console.log(selected)
    // }, [selected])




    const InvoiceComponent = () => {
        switch (location) {
            case '/dashboard/invoices/invoice-details':
                return <Invoicedetails selectedDate={selectedDate} />
                break;

            default:
                return <InvoiceListing selectedDate={selectedDate} />
                break;
        }
    }
    const AMBER = '#F5A300';
    const AMBER_DARK = '#8A5A00';
    return (
        <Box className='mt-1 invoice p-3'>
            <Box className='d-flex align-items-center mb-4  justify-content-between'>
                <Typography className='fw-bold' variant='h6'>Invoice Listing</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker sx={{ width: { xs: "30%", lg: '15%' } }} value={selectedDate} onChange={(newvalue) => { newvalue && setselectedDate(newvalue) }} views={['month', 'year']} />
                </LocalizationProvider>

            </Box>
            {/* <Box className='border-10 p-2 d-flex gap-2 align-items-center mb-2' sx={{background:'#ffbb001A', color:'#ffbb00'}}>
                <Warning sx={{fill:'#ffbb00 !important'}}/>
                <Typography variant='subtitle2'>Please download and save a copy of your invoice each month for your records. Invoices from previous months may not be available for viewing or downloading in the system.</Typography>
            </Box> */}
            <Box
                role="status"
                sx={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: { xs: 'flex-start', sm: 'center' },
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: 2,
                    mb: 2,
                    py: 1.5,
                    pl: 2.5,
                    pr: 2,
                    borderRadius: 2,
                    overflow: 'hidden',
                    bgcolor: alpha(AMBER, 0.08),
                    border: `1px solid ${alpha(AMBER, 0.35)}`,
                    boxShadow: `0 1px 2px ${alpha('#000', 0.04)}`,
                    // left accent bar
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        bottom: 0,
                        width: 4,
                        bgcolor: AMBER,
                    },
                }}
            >
                {/* Icon badge */}
                <Box
                    sx={{
                        flexShrink: 0,
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        display: 'grid',
                        placeItems: 'center',
                        bgcolor: alpha(AMBER, 0.18),
                    }}
                >
                    <WarningAmberRounded sx={{ fill: `${AMBER_DARK} !important`, fontSize: 24 }} />
                </Box>

                {/* Message */}
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: AMBER_DARK, lineHeight: 1.4 }}>
                        Download your invoice each month
                    </Typography>
                    <Typography variant="body2" sx={{ color: alpha(AMBER_DARK, 0.9), mt: 0.25 }}>
                        {/* Please save a copy for your records. Invoices from previous months may not be available
                        to view or download in the system. */}
                        Please download and save a copy of your invoice each month for your records. Invoices from previous months may not be available for viewing or downloading in the system.
                    </Typography>
                </Box>
            </Box>
            <InvoiceComponent />

        </Box>
    );
}

export default Invoices;
